import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import qestIds from '../QestIds';
import {
  InHouseRetestSection,
  MeasurementsSection,
  PreparationSection,
  ResultsSection,
  TheoreticalMaximumDensitySection,
} from './InHouseMethod/Sections';

let AsphaltNuclearFieldDensityWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Preparation">
        <NamePrefixModifier appendNamePrefix="Preparation">
          <PreparationSection />
        </NamePrefixModifier>
      </PageSection>
      <PageSection heading="Retest">
        <NamePrefixModifier appendNamePrefix="Retest">
          <InHouseRetestSection />
        </NamePrefixModifier>
      </PageSection>
      <PageSection heading="Theoretical Maximum Density">
        <NamePrefixModifier appendNamePrefix="TheoreticalMaximumDensity">
          <TheoreticalMaximumDensitySection />
        </NamePrefixModifier>
      </PageSection>
      <PageSection heading="Measurements">
        <NamePrefixModifier appendNamePrefix="Measurements">
          <MeasurementsSection />
        </NamePrefixModifier>
      </PageSection>
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <PageSection heading="Results">
        <ResultsSection />
      </PageSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AsphaltNuclearFieldDensityWorksheet = withInjectedProps(AsphaltNuclearFieldDensityWorksheet);
AsphaltNuclearFieldDensityWorksheet.qestIds = [qestIds.asphaltNuclearFieldDensity.InHouseMethod];

export default AsphaltNuclearFieldDensityWorksheet;
export { AsphaltNuclearFieldDensityWorksheet };
